// Public read of `/api/v2/support/whatsapp` — drives the global WhatsApp FAB.
// Auth-free, so we go through plain fetch + the same dedup of duplicated
// `/api/v2/api/v2` prefixes the typed client uses.

const baseUrl = import.meta.env["VITE_API_BASE_URL"] ?? "/api/v2";

export interface SupportWhatsAppView {
  readonly url: string | null;
}

export async function fetchSupportWhatsApp(): Promise<SupportWhatsAppView> {
  const res = await fetch(`${baseUrl}/support/whatsapp`, {
    credentials: "omit",
  });
  if (!res.ok) {
    throw new Error(`fetchSupportWhatsApp failed status=${res.status}`);
  }
  const json = (await res.json()) as { url: unknown };
  return {
    url: typeof json.url === "string" && json.url.length > 0 ? json.url : null,
  };
}
